export default __webpack_public_path__ + "static/media/slowmotrial1.0edbf481.mp4";